import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { loadPolyfills } from './polyfill';
import runtimeConfig from './routes/runtimeConfig';
import { storeFactory } from './stores';
import IntlProvider from './containers/IntlContainer';
import App from './containers/App';
import { Routes } from './routes/Routes';

import './clients/LoggingClient';

const appDiv = document.getElementById('mbs3');
const store = storeFactory(runtimeConfig.api);

const app = (
  <IntlProvider store={store}>
    <Provider store={store}>
      <Router>
        <App runtimeConfig={runtimeConfig} render={(props) => <Routes {...props} />} />
      </Router>
    </Provider>
  </IntlProvider>
);

loadPolyfills(() => {
  // Polyfills must be loaded before we render the App
  render(app, appDiv);
});
